var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarthquake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4301",
    "data-name": "Group 4301",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.394,
    height: 50,
    viewBox: "0 0 55.394 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2570",
    "data-name": "Rectangle 2570",
    width: 55.394,
    height: 50,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4300",
    "data-name": "Group 4300",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50898",
    "data-name": "Path 50898",
    d: "M32.47,17.81a.823.823,0,0,0-1.006-.591l-6.428,1.666a.827.827,0,0,0-.592,1.006l1.664,6.416a.822.822,0,0,0,1.005.591l3.213-.833h0l3.212-.832a.825.825,0,0,0,.591-1.006ZM31.5,20.634l-1.617.419-.417-1.611,1.617-.419Zm-3.631-.778.417,1.611-1.617.418-.418-1.609Zm-.786,3.627,1.617-.419.418,1.611-1.617.419Zm3.632.777-.418-1.61,1.618-.419.417,1.611Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50899",
    "data-name": "Path 50899",
    d: "M54.569,27.9H41.994L38.3,13.662l2.651-.687a.825.825,0,0,0,.2-1.515L34.462,7.643,32.266.58A.823.823,0,0,0,31.229.039L28.207,1a.825.825,0,0,0-.541,1.017l.612,2.1L24.7,2.078a.824.824,0,0,0-1.114.289L13.769,18.56a.824.824,0,0,0,.912,1.226l2.651-.687,3.755,14.486a.825.825,0,0,0,.8.618.857.857,0,0,0,.207-.026l6.224-1.614,1.113,7.116L16.867,47.088,19.1,38.412a.827.827,0,0,0-.054-.655l-5.033-9.421a.826.826,0,0,0-.728-.436H.825a.825.825,0,1,0,0,1.65H12.79l1.605,3H3.812a.825.825,0,1,0,0,1.65H15.276l2.145,4.016L14.5,48.909a.824.824,0,0,0,1.247.946l15.042-9.11a.825.825,0,0,0,.349-.807l-.9-5.735H48.036a.825.825,0,1,0,0-1.65H29.985l-.47-3H54.569a.825.825,0,1,0,0-1.65M29.475,2.328l1.462-.465,1.425,4.582-1.11-.633-.913-.52ZM28.551,27.9a.825.825,0,0,0-.815.952l.324,2.073-5.583,1.448L18.722,17.887a.827.827,0,0,0-1.006-.592l-1.484.385L24.584,3.909l5.851,3.336,8.14,4.642-1.484.385a.826.826,0,0,0-.592,1.006L40.29,27.9Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50900",
    "data-name": "Path 50900",
    d: "M26.081,37.975a.826.826,0,0,0,.752-.484l.785-1.73a.825.825,0,0,0-1.5-.682l-.785,1.73a.825.825,0,0,0,.751,1.166",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50901",
    "data-name": "Path 50901",
    d: "M17.2,26.885a.825.825,0,1,0,.5-1.571l-2.594-.833a.825.825,0,1,0-.505,1.571Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50902",
    "data-name": "Path 50902",
    d: "M44.932,26.508a.824.824,0,0,0,.625-.286l1.633-1.89a.825.825,0,0,0-1.248-1.079l-1.634,1.891a.825.825,0,0,0,.624,1.364",
    fill: "#3d3d3d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthquake);
export default __webpack_public_path__ + "static/media/Earthquake.6835d76590914b782b149fe376c9fceb.svg";
export { ForwardRef as ReactComponent };